/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CredentialRedeemAvailableResponse } from '../../models/credential-redeem-available-response';
import { CredentialRedeemMfaResponse } from '../../models/credential-redeem-mfa-response';
import { CredentialRedeemSsoResponse } from '../../models/credential-redeem-sso-response';
import { CredentialRedeemUnavailableResponse } from '../../models/credential-redeem-unavailable-response';
import { WebProvisionCredentialRedeemVerifyRequest } from '../../models/web-provision-credential-redeem-verify-request';

export interface VerifyCredentialRedemption$Params {
  id: string;
      body: WebProvisionCredentialRedeemVerifyRequest
}

export function verifyCredentialRedemption(http: HttpClient, rootUrl: string, params: VerifyCredentialRedemption$Params, context?: HttpContext): Observable<StrictHttpResponse<(CredentialRedeemAvailableResponse | CredentialRedeemMfaResponse | CredentialRedeemSsoResponse | CredentialRedeemUnavailableResponse)>> {
  const rb = new RequestBuilder(rootUrl, verifyCredentialRedemption.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<(CredentialRedeemAvailableResponse | CredentialRedeemMfaResponse | CredentialRedeemSsoResponse | CredentialRedeemUnavailableResponse)>;
    })
  );
}

verifyCredentialRedemption.PATH = '/webprovision/{id}/verify';
